import { TLayoutItem } from '@redux/layouts/actions';
import { Form, Input, Modal } from 'antd';
import { useAddShowLayout } from 'hooks/useShowLayout';
import React, { useImperativeHandle, useState } from 'react';
import { useTranslation } from 'react-i18next';

type TAddNewView = {
  existLayouts: TLayoutItem[];
};

const AddNewView = ({ existLayouts }: TAddNewView, ref) => {
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const addShowLayout = useAddShowLayout();

  const onCancel = () => {
    setOpen(false);
    form.resetFields();
  };
  const onFinish = (values) => {
    addShowLayout(values.title);
    onCancel();
  };

  useImperativeHandle(
    ref,
    () => ({
      setOpen,
    }),
    [setOpen],
  );

  return (
    <Modal
      onOk={form.submit}
      onCancel={onCancel}
      open={open}
      title={t('common.addNewView')}
    >
      <Form layout="vertical" form={form} onFinish={onFinish}>
        <Form.Item
          rules={[
            {
              required: true,
              message: t('common.error.required'),
            },
            () => ({
              validator(_, value) {
                if (
                  !value ||
                  !existLayouts.filter((e) => e.title === value).length
                ) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error(t('error.title.exist')));
              },
            }),
          ]}
          name="title"
          label="Title"
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default React.forwardRef(AddNewView);
